import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-headertext',
  templateUrl: './headertext.component.html',
  styleUrls: ['./headertext.component.css'],
})
export class HeadertextComponent implements OnInit {
  @Input() text: string;
  @Input() hideback = false;

  constructor() {}

  ngOnInit(): void {}
}
